<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_757)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6742 6.32576C13.6742 5.77348 13.2265 5.32576 12.6742 5.32576C12.122 5.32576 11.6742 5.77347 11.6742 6.32576V10.5858L8.66196 7.57349C8.27143 7.18296 7.63827 7.18296 7.24774 7.57349C6.85722 7.96401 6.85722 8.59718 7.24774 8.9877L10.26 12L6 12C5.44772 12 5 12.4477 5 13C5 13.5523 5.44771 14 6 14L10.26 14L7.24774 17.0123C6.85721 17.4028 6.85721 18.036 7.24774 18.4265C7.63826 18.817 8.27142 18.817 8.66195 18.4265L11.6742 15.4142V19.6742C11.6742 20.2265 12.122 20.6742 12.6742 20.6742C13.2265 20.6742 13.6742 20.2265 13.6742 19.6742V15.4142L16.6865 18.4265C17.0771 18.817 17.7102 18.817 18.1008 18.4265C18.4913 18.036 18.4913 17.4028 18.1008 17.0123L15.0885 14L19.3485 14C19.9008 14 20.3485 13.5523 20.3485 13C20.3485 12.4477 19.9008 12 19.3485 12L15.0885 12L18.1008 8.9877C18.4913 8.59717 18.4913 7.96401 18.1008 7.57349C17.7102 7.18296 17.0771 7.18296 16.6865 7.57348L13.6742 10.5858V6.32576Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_757">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
